<template>
  <el-tabs class="stock-bound-tabs" :model-value="activeTab" @tab-change="changeTab">
    <el-tab-pane label="库存明细" name="inventory" />
    <el-tab-pane label="外发货品跟踪" name="outbound" />
  </el-tabs>
</template>

<script>
export default {
  name: "StockBoundTabs",
  computed: {
    activeTab() {
      return this.$route.path.indexOf("/stock/bound/outboundTracking") >= 0 ? "outbound" : "inventory";
    }
  },
  methods: {
    changeTab(name) {
      const path = name === "outbound" ? "/stock/bound/outboundTracking" : "/stock/bound/index";
      if (this.$route.path !== path) this.$router.push(path);
    }
  }
};
</script>

<style scoped>
.stock-bound-tabs {
  margin-bottom: 14px;
}
</style>
